import React from "react";
import { Modal, Grid, Typography, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import rotatePhone from "../../images/rotatePhone.svg";

const RotateModal = ({ isOpen, openPopup, setOpenPopup, classes }) => {
  console.log("openPopup", openPopup);
  return (
    <Modal open={isOpen}>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.modalContainer}
      >
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Typography className={classes.modalDescription}>
            Mobile version coming soon.
          </Typography>
          <Button
            onClick={() => setOpenPopup(false)}
            className={classes.nextButton}
          >
            Ok
          </Button> */}
          <img src={rotatePhone} width="200" />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(RotateModal);
